const flag = {
  state: {
    showSidebarMobile: false,
    showSidebarDesktop: false,
    showPopupBirthday: false,
    isUserBirthday: false,
    estoySiendoReemplazado: false,
    estoyReemplazando: false,
    nombreReemplazo: '',
    fechaInicio: '',
    fechaFin: '',
    codigoEmpleadoOrigen: 0,
    codigoEmpleadoReemplazante: 0,
    id: 0,
    documentosPorFirmar: 0, // Nueva propiedad añadida,
    contratosPorFirmar:0,
    cursosSinTerminar:0
  },
  mutations: {
    SET_SIDEBAR_MOBILE (state, payload) {
      state.showSidebarMobile = payload
    },
    SET_SIDEBAR_DESKTOP (state, payload) {
      state.showSidebarDesktop = payload
    },
    SET_POPUP_BIRTHDAY (state, payload) {
      state.showPopupBirthday = payload
    },
    SET_USER_BIRTHDAY (state, payload) {
      state.isUserBirthday = payload
    },
    SET_ESTOY_SIENDO_REEMPLAZADO (state, payload) {
      state.estoySiendoReemplazado = payload
    },
    SET_ESTOY_REEMPLAZANDO (state, payload) {
      state.estoyReemplazando = payload
    },
    SET_NOMBRE_REEMPLAZO (state, payload) {
      state.nombreReemplazo = payload
    },
    SET_FECHA_INICIO (state, payload) {
      state.fechaInicio = payload
    },
    SET_FECHA_FIN (state, payload) {
      state.fechaFin = payload
    },
    SET_CODIGO_EMPLEADO_ORIGEN (state, payload) {
      state.codigoEmpleadoOrigen = payload
    },
    SET_CODIGO_EMPLEADO_REEMPLAZANTE (state, payload) {
      state.codigoEmpleadoReemplazante = payload
    },
    SET_ID (state, payload) {
      state.id = payload
    },
    SET_DOCUMENTOS_POR_FIRMAR (state, payload) { // Nueva mutation añadida
      state.documentosPorFirmar = payload
    },
    SET_CONTRATOS_POR_FIRMAR (state, payload) { // Nueva mutation añadida
      state.contratosPorFirmar = payload
    },
    SET_CURSOS_SIN_TERMINAR (state, payload) {
      state.cursosSinTerminar = payload
    }
  },
  actions: {
    setSidebarMobile ({ commit }, payload) {
      commit('SET_SIDEBAR_MOBILE', payload)
    },
    setSidebarDesktop ({ commit }, payload) {
      commit('SET_SIDEBAR_DESKTOP', payload)
    },
    setPopupBirthday ({ commit }, payload) {
      commit('SET_POPUP_BIRTHDAY', payload)
    },
    setUserBirthday ({ commit }, payload) {
      commit('SET_USER_BIRTHDAY', payload)
    },
    setEstoySiendoReemplazado ({ commit }, payload) {
      commit('SET_ESTOY_SIENDO_REEMPLAZADO', payload)
    },
    setEstoyReemplazando ({ commit }, payload) {
      commit('SET_ESTOY_REEMPLAZANDO', payload)
    },
    setNombreReemplazo ({ commit }, payload) {
      commit('SET_NOMBRE_REEMPLAZO', payload)
    },
    setFechaInicio ({ commit }, payload) {
      commit('SET_FECHA_INICIO', payload)
    },
    setFechaFin ({ commit }, payload) {
      commit('SET_FECHA_FIN', payload)
    },
    setCodigoEmpleadoOrigen ({ commit }, payload) {
      commit('SET_CODIGO_EMPLEADO_ORIGEN', payload)
    },
    setCodigoEmpleadoReemplazante ({ commit }, payload) {
      commit('SET_CODIGO_EMPLEADO_REEMPLAZANTE', payload)
    },
    setId ({ commit }, payload) {
      commit('SET_ID', payload)
    },
    setDocumentosPorFirmar ({ commit }, payload) { // Nueva action añadida
      commit('SET_DOCUMENTOS_POR_FIRMAR', payload)
    },
    setContratosPorFirmar ({ commit }, payload) { // Nueva action añadida
      commit('SET_CONTRATOS_POR_FIRMAR', payload)
    },
    setCursosSinTerminar ({ commit }, payload) {
      commit('SET_CURSOS_SIN_TERMINAR', payload)
    }
  },
  getters: {
    showSidebarMobile: state => state.showSidebarMobile,
    showSidebarDesktop: state => state.showSidebarDesktop,
    showPopupBirthday: state => state.showPopupBirthday,
    isUserBirthday: state => state.isUserBirthday,
    estoySiendoReemplazado: state => state.estoySiendoReemplazado,
    estoyReemplazando: state => state.estoyReemplazando,
    nombreReemplazo: state => state.nombreReemplazo,
    fechaInicio: state => state.fechaInicio,
    fechaFin: state => state.fechaFin,
    codigoEmpleadoOrigen: state => state.codigoEmpleadoOrigen,
    codigoEmpleadoReemplazante: state => state.codigoEmpleadoReemplazante,
    id: state => state.id,
    documentosPorFirmar: state => state.documentosPorFirmar, // Nuevo getter añadido
    contratosPorFirmar: state => state.contratosPorFirmar, // Nuevo getter añadido
    cursosSinTerminar: state => state.cursosSinTerminar
  }
}

export default flag



// WEBPACK FOOTER //
// ./src/store/flag.js